export const userKeys = {
  all: ['users'] as const,
  lists: () => [...userKeys.all, 'list'] as const,
  list: (filters?: string) =>
    filters ? ([...userKeys.lists(), { filters }] as const) : userKeys.lists(),
  details: () => [...userKeys.all, 'detail'] as const,
  detail: (id: string) => [...userKeys.details(), id] as const,
  roles: () => ['roles'] as const,
  lookup: (email: string) => ['users', 'lookup', email] as const,
  search: (query: string, limit?: number, continuationToken?: string) =>
    continuationToken
      ? (['users', 'search', query, { limit, continuationToken }] as const)
      : (['users', 'search', query, { limit }] as const),
  siteAssignments: (userId: string) =>
    ['users', userId, 'site-assignments'] as const,
  pendingInvites: () => ['users', 'invites', 'pending'] as const,
  offboardReadiness: (userId: string) =>
    ['users', userId, 'offboard-readiness'] as const,
};
